import { FormaDePagoId } from '../tipos';

const valores: Record<FormaDePagoId, number> = {
    contado: 0,
    tarjeta: 20_000,
    cheque: 20_000,
    pagare: 40_000,
};

export function gastoNotarialPorFormaDePago(forma: FormaDePagoId): number {
    return valores[forma];
}



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/servicios/gastoNotarialPorFormaDePago.ts